import {
    AfterViewInit,
    Component,
    EventEmitter,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    Output,
    PLATFORM_ID
} from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { debounceTime, throttleTime } from 'rxjs/operators';
import { fromEvent, Subscription } from 'rxjs';
import { isPlatformBrowser } from "@angular/common";
import { Store } from 'src/app/store';

@Component({
    selector: 'app-product-details-order, [app-product-details-order]',
    templateUrl: './product-details-order.component.html',
    styleUrls: ['./product-details-order.component.scss'],
    animations: [
        trigger('fade', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate(300, style({ opacity: 1 })),
            ])
        ]),
    ],
})
export class ProductDetailsOrderComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() sku;
    @Input() product;
    @Input() qty;
    @Input() stickyBehavior;
    @Output() newOrder = new EventEmitter<boolean>();
    isStickyTop = false;
    orderBarEl;
    navHeight = 0;
    publicTelNo$ = this.store.select<string>('publicTelNo');

    private scrollSubscription: Subscription;
    private resizeSubscription: Subscription;
    private isBrowser: boolean;

    constructor(
        private store: Store,
        @Inject(PLATFORM_ID) platformId: {}
    ) {
        this.isBrowser = isPlatformBrowser(platformId);
    }

    ngOnInit(): void {
        this.scrollSubscription = fromEvent(window, 'scroll')
            .pipe(throttleTime(0))
            .subscribe(() => {
                this.onWindowScroll();
            });

        this.resizeSubscription = fromEvent(window, 'resize')
            .pipe(debounceTime(500))
            .subscribe(() => {
                this.onWindowResize();
            });
    }

    ngAfterViewInit(): void {
        if (this.isBrowser) {
            this.onWindowResize();
        }
    }

    ngOnDestroy() {
        this.scrollSubscription.unsubscribe();
        this.resizeSubscription.unsubscribe();
    }

    onWindowScroll() {
        if (this.stickyBehavior) {
            const orderDetailsPosition = document.getElementById('product-details').getBoundingClientRect();
            this.isStickyTop = orderDetailsPosition.top <= this.navHeight + 1;
        }
    }

    onWindowResize() {
        this.navHeight = document.getElementById('header').offsetHeight;
    }

    setOrder(isSample: boolean) {
        this.newOrder.emit(isSample);
    }

}
